import { useAdmin } from '@vtex/raccoon-next'
import { markLoggedRequestError, toRequestLog } from 'shared'
import { type LogType, LOG_TYPE_REQUEST } from 'typings'
import { useLogger } from './useLogger'

interface FetcherWrapperOptions extends RequestInit {
  timeout?: number
}

export function useFetch() {
  const { logger } = useLogger()
  const { account, workspace, token } = useAdmin()

  const sendlog = (error: unknown) => {
    const requestLog = toRequestLog(error)
    const data: LogType = {
      message: requestLog.message,
      metadata: requestLog.metadata,
      level: requestLog.level,
      type: LOG_TYPE_REQUEST,
    }
    logger(data)
    markLoggedRequestError(error)
  }

  const fetcherWrapper = async (
    url: string | URL,
    options: FetcherWrapperOptions = {}
  ) => {
    const headers = new Headers({ ...options.headers })
    headers.set('account', account)
    headers.set('workspace', workspace)
    headers.set('VtexIdclientAutCookie', token)

    try {
      const response = await fetch(url, { ...options, headers })

      if (!response.ok) {
        throw response
      }
      return response
    } catch (error) {
      sendlog(error)
      throw error
    }
  }
  return { fetcherWrapper }
}
